import styled from 'styled-components';

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Logo = styled.img`
  padding-top: 30px;
`;
